import * as React from "react";
import { Box, styled } from "@mui/material";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import { StyledIndividualTabV2, StyledTabContainer } from "../../Components/CustomTab";

const AlertTab = styled(StyledIndividualTabV2)(() => ({
    fontSize: "15px",
    lineHeight: '24px',
}));

const AlertSystemTabs = ({
    tabs = [],
    selectedTab,
    changeTheTab = () => { },
}) => {
    const handleChange = (event, newValue) => {
        changeTheTab(newValue);
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <Box sx={{ flexGrow: 1 }}>
                <StyledTabContainer
                    value={selectedTab}
                    onChange={handleChange}
                    aria-label="secondary tabs"
                    elevation={1}
                    myColor={ThemeProperties.purple}
                >
                    {tabs.map((item) => (
                        <AlertTab value={item.slug} key={item.id} label={item.name} />
                    ))}
                </StyledTabContainer>
            </Box>
        </Box>
    );
}

export default AlertSystemTabs;
